import Script from 'next/script'
import HubspotSubmitForm from './HubspotSubmitForm'
import { Typography } from '@mui/material'
import { Divider, TextContainer } from './styled'
import { SUBSCRIBE_FORM_ID } from '../constants'

const SubscribeForm = () => {
  return (
    <div>
      <Script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="https://js.hs-scripts.com/3838537.js"
      />
      <TextContainer>
        <Typography variant="h6">Subscribe</Typography>
        <Divider />
        <Typography variant="body2">
          Sign up to get relevant content. Free of charge, free of spam.
        </Typography>
      </TextContainer>
      <HubspotSubmitForm formId={SUBSCRIBE_FORM_ID} portalId="3838537" />
    </div>
  )
}

export default SubscribeForm
